








































import { Prop, Ref, Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'
import CodeInput from '@/modules/login/components/SmsForm/CodeInput.vue'
import FormCard from '@/modules/login/components/common/FormCard.vue'
import LoginStore from '@/modules/login/stores/LoginStore'
import UserAvatar from '@/modules/login/components/common/UserAvatar.vue'
import CodeTimeout from '@/modules/login/components/SmsForm/CodeTimeout.vue'
import RefreshCodeButton from '@/modules/login/components/SmsForm/RefreshCodeButton.vue'

const DEFAULT_RESET_TIMEOUT = 60

@Component({
  components: {
    RefreshCodeButton,
    CodeTimeout,
    FormCard,
    CodeInput,
    UserAvatar,
  },
})
export default class SmsForm extends Vue {
  @Prop(String) title?: string
  @Prop(String) description?: string
  @Prop(Boolean) hasTimeout?: boolean
  @Prop(Boolean) hasResetButton?: boolean

  isPending: boolean = false
  timeoutValue = DEFAULT_RESET_TIMEOUT
  isAllowRefreshCode = false

  @Ref('codeInput') codeInput?: CodeInput & {
    clear: Function
  }

  get currentUser() {
    return LoginStore.currentUser
  }

  get hasError(): boolean {
    return !!LoginStore.errorMessage
  }

  login(code: string) {
    this.isPending = true

    LoginStore.login(code)
      .then(url => {
        if (url) {
          location.assign(url)
        }
      })
      .catch(() => {
        if (this.codeInput) {
          this.codeInput.clear()
        }
      })
      .finally(() => (this.isPending = false))
  }

  resetCode() {
    if (this.codeInput) {
      this.codeInput.clear()
      this.timeoutValue = DEFAULT_RESET_TIMEOUT
    }
  }

  clearErrors() {
    LoginStore.setErrors({})
  }

  showPhoneForm() {
    LoginStore.setAuthMethod(null)
  }

  allowRefreshCode() {
    this.isAllowRefreshCode = true
  }
}
